export enum ScreenViewName {
	PITCH_MANAGER = 'pitch_manager',
	PITCH_ADD = 'add_pitch',
	PITCH_EDIT = 'edit_pitch',
	EDIT_ARTIST = 'edit_artist_page',
	ANALYTICS_ARTIST = 'analytics_artist_page',
	ANALYTICS_TRACK = 'analytics_track_page',
	ANALYTICS_PLAYLIST = 'analytics_playlist_page',
	ANALYTICS_ALBUM = 'analytics_album_page',
	REQUEST_MONITORING = 'request_monitoring_page',
	USER_MANAGER = 'user_manager_page',
	SUB_LABEL = 'sublabel_management_page',
	DELIVERY_MONITORING = 'delivery_monitoring_page',
	PLAYLIST_REPORT = 'playlist_report_page',
	CHARTS = 'charts_page',
	OVERVIEW = 'analytics_page',
	CAMPAIGN_MANAGER = 'campaign_manager',
	CAMPAIGN_MANAGER_INFORMATION = 'campaign_information',
	CAMPAIGN_MANAGER_CREATE = 'new_campaign',
}
